import React, { useState, useEffect } from "react";
import Loading from "../../components/Loading/Loading";
import {
  deleteValueAddedFeature,
  getAllValueAddedFeatures,
} from "../../services/Admin.service";
import messageBox from "../../utils/messagebox";
import ModalValueAddedFeatures from "./ModalValueAddedFeatures";

function ValueAddedFeatures() {
  let [loading, setLoading] = useState(true);
  let [features, setFeatures] = useState([]);
  let [activeModal, setActiveModal] = useState(false);
  let [isUpdate, setIsUpdate] = useState(false);
  let [dataUpdate, setDataUpdate] = useState({});

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    await getAllValueAddedFeatures()
      .then(({ data }) => {
        setFeatures(data);
        setLoading(false);
      })
      .catch((err) => messageBox.Simple(err, "error"));
  }

  function editValueAddedFeatureFC(feature) {
    setDataUpdate(feature);
    setIsUpdate(true);
    setActiveModal(true);
  }

  async function deleteValueAddedFeatureFC(id) {
    await deleteValueAddedFeature(id)
      .then(({ data }) => {
        messageBox.Simple(data.message, "success");
        setFeatures(features.filter((feature) => feature.id !== id)); // Actualiza la lista sin recargar la página
      })
      .catch((err) => messageBox.Simple(err, "error"));
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="ml-8 mt-10">
            <h1
              className="mb-2 font-weight-bold"
              style={{
                fontFamily: "Poppins",
                fontSize: "40px",
                marginTop: "10px",
                marginBottom: "20px",
                color: "rgb(0, 71, 80)",
                fontWeight: "700",
              }}
            >
              Panel de Valores Agregados
            </h1>
          </div>
          <div className="flex flex-col mx-6">
            <div className="overflow-x-auto">
              <div className="py-3 pl-2">
                <div className="relative">
                  <div className="lg:flex block justify-between">
                    <div className="lg:flex lg:justify-end lg:mb-5">
                      <button
                        type="button"
                        className="btn rounded-pill ColorButtonMainInv lg:text-sm xl:text-md lg:ml-2 flex"
                        onClick={() => {
                          setDataUpdate({});
                          setIsUpdate(false);
                          setActiveModal(true);
                        }}
                      >
                        Crear nuevo valor agregado
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-1.5 w-full inline-block align-middle">
                <div className="overflow-auto border rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200 table-auto">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase"
                        >
                          ID
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase"
                        >
                          Nombre
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase"
                        >
                          Descripción
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase"
                        ></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {features.length === 0 ? (
                        <tr>
                          <td className="text-center p-3 fs-5" colSpan="4">
                            No hay valores agregados registrados.
                          </td>
                        </tr>
                      ) : (
                        features.map((feature) => (
                          <tr key={feature.id}>
                            <td className="px-6 py-4 text-sm font-medium text-gray-500 whitespace-nowrap">
                              {feature.id}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-gray-500 whitespace-nowrap">
                              {feature.name}
                            </td>
                            <td
                              className="px-6 py-4 text-sm text-gray-1000"
                              style={{ maxWidth: 800, textAlign: 'justify' }}
                            >
                              {feature.description}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-right whitespace-nowrap">
                              <button
                                className="text-green-500 hover:text-green-700 mx-2"
                                onClick={() => editValueAddedFeatureFC(feature)}
                              >
                                Modificar
                              </button>
                              <button
                                className="text-yellow-500 hover:text-yellow-700 mx-2"
                                onClick={() =>
                                  deleteValueAddedFeatureFC(feature.id)
                                }
                              >
                                Eliminar
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {activeModal && (
            <div
              className="App h-screen ml-[90px] flex flex-col items-center justify-center bg-purple-200 vw-100 vh-100"
              style={{
                zIndex: "10",
                background: "rgba(0, 162, 151, .55)",
                position: "fixed",
                top: "0",
                right: "0",
                bottom: "0",
                left: "0",
                overflowX: "hidden",
                overflowY: "auto",
              }}
            >
              <ModalValueAddedFeatures
                setActiveModal={setActiveModal}
                isUpdate={isUpdate}
                dataUpdate={dataUpdate}
                setDataUpdate={setDataUpdate}
              />
            </div>
          )}
        </>
      )}
    </>
  );
}

export default ValueAddedFeatures;
